export enum RequisitesDistributionMode {
  Random = 'random',
  Sequential = 'sequential',
}
